<template>
  <div>
    <div class="addClassButtonContainer">
      <div class="addClassButton" @click="toggleAdminNewClassPopUp">
        <div class="addClassText">Add Class</div>
        <img class="addClassIcon" alt="" src="/static/img/white_plus.svg" />
      </div>
    </div>
    <div class="courseSectionContainer">
      <div class="courseHeader">
        <b class="courseTitle">Unassigned Students</b>
      </div>
      <div class="cardsContainer unassignedCards">
        <UnassignedStudentsCard
          v-for="(group, key) of displayStudents"
          v-bind:key="key"
          :students="group"
          :classes="classes"
          @new="toggleAdminNewClassPopUp"
          @assign="assignStudentToClass"
        ></UnassignedStudentsCard>
      </div>
    </div>
    <div
      class="courseSectionContainer"
      v-for="program of programs"
      v-bind:key="program.id"
    >
      <div class="courseHeader">
        <b class="courseTitle">{{ program.name }} Pilot</b>
      </div>
      <div class="cardsContainer">
        <ClassCards
          v-for="classObj of classes.filter(
            (data) => data.curriculum.programId === program.id,
          )"
          v-bind:key="classObj.id"
          :course="classObj"
          @goToClassGradeBook="goToClassGradeBook(classObj.id)"
          @class="openClassView"
          @archive="preArchiveClass"
          @notes="toggleNotesModal"
          @remove="removeStudentFromClass"
        />
      </div>
    </div>
    <admin-new-class-pop-up
      :courses="programs"
      :curriculums="curriculums"
      :instructors="instructors"
      :students="students"
      :aircraft="aircraft"
      :is-visible="isAdminNewClassPopUpOpen"
      @close="toggleAdminNewClassPopUp"
      @save="saveNewClass"
    ></admin-new-class-pop-up>
    <notes
      :is-visible="isNotesModalOpen"
      @close="toggleNotesModal"
      :target-name="
        selectedStudent.user?.firstName + ' ' + selectedStudent.user?.lastName
      "
      :target-user-id="selectedStudent.studentId"
      noteTypeName="Classroom"
    ></notes>
    <el-dialog
      center
      :title="
        selectedForArchive
          ? 'Archive ' +
            selectedForArchive.activeInstructor.user.firstName +
            ' ' +
            selectedForArchive.activeInstructor.user.lastName +
            '\'s ' +
            selectedForArchive.curriculum.program.name +
            ' Class'
          : 'Archive Class'
      "
      :visible.sync="modals.archive"
    >
      <div class="text-center" v-if="selectedForArchive">
        <span
          >Archiving this class will save the student's current grades and make
          them available to be added to a new class.</span
        >
        <br />
        <span>This will also set this class as inactive.</span>
        <br />
        <br />
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="archiveClass" icon=""
            >Archive Class</el-button
          >
          <el-button type="danger" @click="closeModal('archive')" icon=""
            >Cancel</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import PortalPopup from "../components/PortalPopup.vue";
import { Dialog, Button } from "element-ui";
import AdminNewClassPopUp from "@/pages/Dashboard/HiloPages/Classroom/AdminNewClassPopUp.vue";
import ClassCards from "@/pages/Dashboard/HiloPages/Classroom/ClassCards.vue";
import UnassignedStudentsCard from "./Classroom/ClassroomComponents/UnassignedStudentsCard.vue";
import ClassesAPIService from "../../../servicehandlers/ClassesAPIService";
const classesAPIService = new ClassesAPIService();
import ProgramsAPIService from "../../../servicehandlers/ProgramsAPIService";
const programsAPIService = new ProgramsAPIService();
import ActiveInstructorsAPIService from "../../../servicehandlers/ActiveInstructorsAPIService";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
import ActiveStudentsAPIService from "../../../servicehandlers/ActiveStudentsAPIService";
const activeStudentsAPIService = new ActiveStudentsAPIService();
import Notes from "../../../components/HiloComponents/NotesModal.vue";
import CurriculumsAPIService from "../../../servicehandlers/CurriculmsAPIService";
const curriculumAPIService = new CurriculumsAPIService();
import AircraftAPIService from "../../../servicehandlers/AircraftAPIService";
const aircraftAPIService = new AircraftAPIService();

export default {
  name: "Frame",
  components: {
    Notes,
    ClassCards,
    AdminNewClassPopUp,
    UnassignedStudentsCard,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  data() {
    return {
      isAdminNewClassPopUpOpen: false,
      isNotesModalOpen: false,
      selectedStudent: {},
      classes: [],
      programs: [],
      instructors: [],
      students: [],
      displayStudents: [],
      curriculums: [],
      aircraft: [],
      modals: {
        archive: false,
      },
      selectedForArchive: null,
    };
  },
  mounted() {
    this.getClasses();
    this.getPrograms();
    this.getInstructors();
    this.getStudents();
    this.getCurriculum();
    this.getAircraft();
  },
  methods: {
    getClasses() {
      return classesAPIService.get(this.$router).then((response) => {
        for (let classObj of response) {
          classObj.startDate = new Date(classObj.startDate);
          classObj.endDate = new Date(classObj.endDate);
        }

        this.classes = response;
      });
    },
    getPrograms() {
      return programsAPIService.get(this.$router).then((response) => {
        this.programs = response;
      });
    },
    getCurriculum() {
      return curriculumAPIService
        .getAllCurriculums(this.$router)
        .then((response) => {
          this.curriculums = response;
        });
    },
    getAircraft() {
      return aircraftAPIService.get(this.$router).then((response) => {
        this.aircraft = response;
        for (let aircraft of this.aircraft) {
          aircraft.name = aircraft.tailNumber + " " + aircraft.model;
        }
      });
    },
    getInstructors() {
      return activeInstructorsAPIService.get(this.$router).then((response) => {
        for (let user of response) {
          user.name = user.user.firstName + user.user.lastName;
        }
        this.instructors = response;
      });
    },
    getStudents() {
      return activeStudentsAPIService
        .getAvailableStudentsToClasses(this.$router)
        .then((response) => {
          for (let user of response) {
            user.name = user.firstName + user.lastName;
            user.activeStudent.startDate = new Date(
              user.activeStudent.startDate,
            );
          }
          this.students = response;

          this.displayStudents = [];
          let temp = [];
          for (let student of this.students) {
            if (temp.length === 3) {
              this.displayStudents.push(temp);
              temp = [];
            }
            if (student) temp.push(student);
          }
          this.displayStudents.push(temp);
        });
    },
    toggleAdminNewClassPopUp() {
      this.isAdminNewClassPopUpOpen = !this.isAdminNewClassPopUpOpen;
      //this.lockScrolling();
    },
    toggleNotesModal(student = {}) {
      this.selectedStudent = student;
      this.isNotesModalOpen = !this.isNotesModalOpen;
      this.lockScrolling();
    },
    lockScrolling() {
      this.$nextTick(() => {
        const content = document.querySelector(".content");
        const viewHeight = document.body.clientHeight;

        if (content) {
          if (this.isAdminNewClassPopUpOpen || this.isNotesModalOpen) {
            content.style.height = viewHeight - 110 + "px";
            content.style.minHeight = content.style.height;
            content.style.overflow = "hidden";
          } else {
            content.style.height = "";
            content.style.overflow = "";
            content.style.minHeight = "calc(100vh - 65px)";
          }
        }
      });
    },
    saveNewClass(classObj) {
      return classesAPIService.create(classObj, this.$router).then(() => {
        this.getClasses();
        this.getStudents();
        this.toggleAdminNewClassPopUp();
      });
    },
    goToClassGradeBook(classId) {
      this.$router.push({
        name: "Admin Class Grade Book",
        query: {
          classId,
        },
      });
    },
    openClassView(classId) {
      //  /hilo/classroomDashboard/adminClassView/' + classObj.id + '?month=' + month.label + '&curriculumId=' + classObj.curriculumId

      let classObj = this.classes.find((data) => data.id === classId);
      let startDate = new Date(classObj.startDate);

      this.$router.push({
        name: "Admin Class View",
        params: {
          id: classId,
        },
        query: {
          month: startDate.toLocaleDateString("default", { month: "long" }),
          curriculumId: classObj.curriculumId,
        },
      });
    },
    preArchiveClass(id) {
      this.selectedForArchive = this.classes.find((data) => data.id === id);
      this.openModal("archive");
    },
    archiveClass() {
      return classesAPIService
        .archiveClass(this.selectedForArchive, this.$router)
        .then(() => {
          this.closeModal("archive");
          this.getClasses();
        });
    },
    assignStudentToClass(payload) {
      return classesAPIService
        .addStudentToClass(payload, this.$router)
        .then(() => {
          this.getClasses();
          this.getStudents();
        });
    },
    removeStudentFromClass(studentId) {
      return classesAPIService
        .removeStudentFromClass(studentId, this.$router)
        .then(() => {
          this.getClasses();
          this.getStudents();
        });
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
  },
};
</script>
<style scoped>
.addClassText {
  position: relative;
  line-height: 25px;
}
.dashboardTitle {
  width: 300px;
  position: relative;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
.addClassIcon {
  width: 10px;
  position: relative;
  height: 10px;
}
.addClassButton {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 5px;
  background-color: #3c78ff;
  height: 29px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  gap: 5px;
  cursor: pointer;
}
.addClassButtonContainer {
  width: 100%;
  position: relative;
  height: 29px;
  text-align: center;
  font-size: 18px;
  color: #fff;
}
.dashboardTitleContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.dashboardHeader {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 20px;
  z-index: 7;
  text-align: left;
  font-size: 25px;
  color: #404040;
}
.courseTitle {
  width: 300px;
  position: relative;
  font-size: 25px;
  display: inline-block;
  color: #404040;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
.courseHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  gap: 10px;
}
.cardsContainer {
  display: flex;
  gap: 30px;
  overflow-x: auto;
  padding-bottom: 10px;
  width: 100%;
  scroll-snap-type: x mandatory;
  flex-direction: row;
}

.cardsContainer > * {
  flex: 0 0 calc(33.333% - 20px);
  scroll-snap-align: start;
}

.unassignedCards > * {
  flex: 0 0 calc(50% - 20px);
  scroll-snap-align: start;
}

.cardsContainer::-webkit-scrollbar {
  height: 8px;
}

.cardsContainer::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.cardsContainer::-webkit-scrollbar-track {
  background: transparent;
}

@media (max-width: 768px) {
  .cardsContainer {
    gap: 20px;
  }
}
.courseSectionContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 20px;
  z-index: 6;
}
.dashboardContainer {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: center;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.75);
  font-family: Helvetica, Arial, sans-serif;
}
</style>
